<template>
  <Loader v-if="isLoading"></Loader>
  <div class="b-booking-progress">
    <div class="b-booking-progress__desktop">
      <div class="b-booking-progress__wrapper">
        <div v-if="showProgressInfoOnBar" class="b-booking-progress__labels">
          <!-- translated -->
          <div
            v-if="selectedMovie.transl"
            class="e-label e-label--bg e-label--translated">
            {{ dictionary.translatable }}
          </div>
          <!-- only members -->
          <div
            v-if="selectedMovie.onlyMembers"
            class="e-label e-label--bg-goldenrod e-label--members">
            {{ dictionary.onlyMembers }}
          </div>
        </div>

        <div class="b-booking-progress__selected-movie">
          <div>
            <div
              v-if="showProgressInfoOnBar"
              class="b-booking-progress__selected-wrapper">
              <!-- poster -->
              <div v-if="movieSelected" class="b-booking-progress__img">
                <img :src="selectedMovie.thumb" :alt="selectedMovie.title" />
              </div>
              <!-- movie name -->
              <div
                v-if="movieSelected"
                class="b-booking-progress__title-wrapper">
                <div class="b-booking-progress__title">
                  {{ selectedMovie.title }}
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ selectedMovie.subTitle }}
                </div>
              </div>
              <hr
                v-if="screenSelected"
                width="1"
                class="b-booking-progress__divide" />
              <!-- date -->
              <div v-if="screenSelected">
                <div class="b-booking-progress__title">
                  {{ selectedDay.formattedDate }}
                  <span v-if="selectedRoom.showtime">
                    @
                    {{ getShowTime(selectedRoom.showtime) }}
                  </span>
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ selectedCinema.display }}
                </div>
              </div>
              <hr
                v-if="screenSelected"
                width="1"
                class="b-booking-progress__divide" />
              <!-- screen & room -->
              <div v-if="screenSelected">
                <div class="b-booking-progress__title">
                  {{ getRoomType(selectedRoom) }}
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ selectedRoom.screenName }}
                </div>
              </div>

              <hr
                v-if="ticketsSelectedLength"
                width="1"
                class="b-booking-progress__divide" />
              <!-- tickets number -->
              <div v-if="ticketsSelectedLength">
                <div class="b-booking-progress__title">
                  {{ ticketsSelectedLength }}
                </div>
                <div class="b-booking-progress__subtitle">
                  <span v-if="ticketsSelectedLength === 1">
                    {{ dictionary.ticketsSingle }}
                  </span>
                  <span v-else>{{ dictionary.tickets }}</span>
                </div>
              </div>
              <hr
                v-if="productSelectedLength"
                width="1"
                class="b-booking-progress__divide" />
              <!-- shopping number -->
              <div v-if="productSelectedLength">
                <div class="b-booking-progress__title">
                  {{ productSelectedLength }}
                  {{ dictionary.step3ShoppingTitle }}
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ dictionary.step3Shopping }}
                </div>
              </div>
              <hr
                v-if="ticketsSelectedLength"
                width="1"
                class="b-booking-progress__divide" />
              <!-- total cost -->
              <div v-if="ticketsSelectedLength" class="">
                <div class="b-booking-progress__title">
                  {{ roundToDigits(store.getTotalCart) }} €
                  <span
                    class="b-booking-progress__points"
                    v-if="store.getTotalUsedPoints > 0">
                    {{
                      dictionary.pointsLabel.replace(
                        '{x}',
                        store.getTotalUsedPoints
                      )
                    }}
                  </span>
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ dictionary.totalCost }}
                </div>
              </div>
            </div>
          </div>
          <!-- actions -->
          <div class="b-booking-progress__actions">
            <button
              v-if="!disabledPrevButton"
              type="button"
              class="b-booking-progress__actions__cta__prev"
              @click="restartBooking">
              <span>{{ dictionary.buttonPreviousPaymentText }}</span>
            </button>
            <button
              id="nextStepBtn"
              type="button"
              class="b-booking-progress__actions__cta__next btn-primary-orange"
              :disabled="disabledNextButton"
              @click="goToNextStep">
              <span>{{ buttonNextText }}</span>
            </button>
          </div>
        </div>
        <!-- progress bar -->
        <div
          class="b-booking-progress__progress-bar"
          :style="progressStyle"></div>
      </div>
    </div>
    <div class="b-booking-progress__mobile">
      <div class="b-booking-progress__mobile__wrapper">
        <div
          v-if="showProgressInfoOnBar"
          class="b-booking-progress__mobile__expand"
          :class="collapseOpened"
          @click="openExpand">
          <div
            class="b-booking-progress__mobile__expand__header"
            :class="childcollapseOpened">
            <div class="b-booking-progress__mobile__expand__header-container">
              <!-- translated -->
              <div
                v-if="selectedMovie.transl"
                class="e-label e-label--translated b-booking-progress__mobile__expand__header--badge">
                {{ dictionary.translatable }}
              </div>
              <!-- only members -->
              <div
                v-if="selectedMovie.onlyMembers"
                class="e-label e-label--members b-booking-progress__mobile__expand__header--badge">
                {{ dictionary.onlyMembers }}
              </div>
              <div
                v-if="movieSelected"
                class="b-booking-progress__mobile__title-wrapper">
                <div class="b-booking-progress__title">
                  {{ selectedMovie.title }}
                </div>
                <div class="b-booking-progress__subtitle">
                  {{ selectedMovie.subTitle }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="daySelected && openCollapse"
            class="b-booking-progress__mobile__expand__content">
            <div v-if="daySelected">
              <div class="b-booking-progress__mobile__expand__title">
                {{ selectedDay.formattedDate }}
                <span v-if="selectedRoom.showtime">
                  @
                  {{ getShowTime(selectedRoom.showtime) }}
                </span>
              </div>
              <div class="b-booking-progress__mobile__expand__subtitle">
                {{ selectedCinema.display }}
              </div>
            </div>
            <div v-if="screenSelected">
              <div class="b-booking-progress__mobile__expand__title">
                {{ getRoomType(selectedRoom) }}
              </div>
              <div class="b-booking-progress__mobile__expand__subtitle">
                {{ selectedRoom.screenName }}
              </div>
            </div>
            <div v-if="ticketsSelectedLength">
              <div class="b-booking-progress__mobile__expand__title">
                {{ ticketsSelectedLength }}
              </div>
              <div class="b-booking-progress__mobile__expand__subtitle">
                {{ dictionary.wizardStep2 }}
              </div>
            </div>
            <div v-if="productSelectedLength">
              <div class="b-booking-progress__mobile__expand__title">
                {{ productSelectedLength }} {{ dictionary.step3ShoppingTitle }}
              </div>
              <div class="b-booking-progress__mobile__expand__subtitle">
                {{ dictionary.step3Shopping }}
              </div>
            </div>
            <div v-if="ticketsSelectedLength || productSelectedLength">
              <div class="b-booking-progress__mobile__expand__title">
                {{ roundToDigits(store.getTotalCart) }} €
                <span
                  class="b-booking-progress__points"
                  v-if="store.getTotalUsedPoints > 0">
                  {{ store.concatPointsLabel(store.getTotalUsedPoints) }}
                </span>
              </div>
              <div class="b-booking-progress__mobile__expand__subtitle">
                {{ dictionary.totalCost }}
              </div>
            </div>
          </div>
        </div>
        <div class="b-booking-progress__mobile__footer">
          <button
            v-if="!disabledPrevButton"
            type="button"
            class="b-booking-progress__actions__cta__prev"
            @click="restartBooking">
            <span>{{ dictionary.buttonPreviousPaymentText }}</span>
          </button>
          <button
            id="nextStepBtn"
            type="button"
            class="b-booking-progress__mobile__cta btn-primary-orange"
            :disabled="disabledNextButton"
            @click="goToNextStep">
            <span>{{ buttonNextText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  getCurrentInstance,
  onMounted,
  ref,
  toRefs,
  watch,
} from 'vue'
import { useBookingStore } from '../../store/BookingStore'
import { extractFullTimeFromDate } from '../../../lib/date'
import { useRouter } from 'vue-router'
import constants from '../../../lib/constants'
import { getData, scrollToTop } from '../../../lib/lib'
import postRequestHandler from '../../../lib/postRequestHandler'
import Loader from './../../components/Shared/Loader.vue'
import jQuery from 'jquery'
const emit = defineEmits({
  changeStep: 0,
})

const { dictionary, configuration } =
  getCurrentInstance().appContext.config.globalProperties
const {
  refresh,
  endpointChooseTickets,
  endpointFetchShopItems,
  endpointAddShopItems,
  endpointCheckContest,
  captchaTicketAction,
  captchaShopAction,
  captchaAddShopItemsAction,
  language,
} = configuration
const store = useBookingStore()
const {
  selectedMovie,
  selectedDay,
  selectedRoom,
  selectedCinema,
  wizardStep,
  paymentDetails,
  voucherType,
  selectedTickets,
  userVouchersCodes,
} = toRefs(store.bookingProgress)
const router = useRouter()
const routeObj = {}
getData('bookingRouteData').routes.forEach((r, index) => {
  routeObj[index + 1] = r.name
})
const stepsRoutes = routeObj

const isLoading = ref(false)
const roundToDigits = (price) => {
  return (
    price &&
    parseFloat(price).toLocaleString(document.documentElement.lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  )
}

const showProgressInfoOnBar = computed(() => {
  return wizardStep.value + 1 !== 5
})

const progress = ref(0)
const wizardProgressStep = computed(() => {
  const { totalWizardSteps, wizardStep } = store.bookingProgress

  return (100 / totalWizardSteps) * (wizardStep + 1) - 10
})
const progressStyle = computed(() => {
  return {
    '--progress': `${progress.value}`,
    '--progress-color':
      wizardProgressStep.value > 20
        ? `var(--c-accent-accent)`
        : 'var(--c-background-midnight-blue)',
  }
})

const movieSelected = computed(() => {
  return Object.keys(selectedMovie.value).length
})

const daySelected = computed(() => {
  return selectedDay.value && Object.keys(selectedDay.value).length
})

const screenSelected = computed(() => {
  return selectedRoom.value && Object.keys(selectedRoom.value).length
})

const ticketsSelectedLength = computed(() => {
  return voucherType.value !== constants.prepaidVoucherType
    ? store.getSelectedTicketsCount
    : 0
})

const productSelectedLength = computed(() => {
  return store.getSelectedProductsCount
})

const disabledNextButton = computed(() => {
  let isDisabled
  switch (wizardStep.value) {
    case 0:
      isDisabled =
        !selectedRoom.value || Object.keys(selectedRoom.value).length === 0
      break
    case 1:
      if (
        voucherType.value === constants.prepaidVoucherType ||
        voucherType.value === constants.discountVoucherType
      ) {
        isDisabled = !userVouchersCodes.value || !userVouchersCodes.value.length
      } else {
        isDisabled =
          !selectedTickets.value ||
          Object.keys(selectedTickets.value).length === 0
      }
      break
    case 2:
      isDisabled = store.hasSeatsRemainingAllocate
      break
    case 4:
      isDisabled = paymentDetails.value.invalid
      break
    default:
      isDisabled = false
  }

  return isDisabled
})

const disabledPrevButton = computed(() => {
  return store.bookingProgress.wizardStep === 0
})

const stepIsPayment = computed(() => {
  return wizardStep.value === 4
})

const buttonNextText = computed(() => {
  return stepIsPayment.value
    ? dictionary.buttonNextPaymentText
    : dictionary.buttonNextText
})

onMounted(() => {
  setTimeout(() => {
    progress.value = wizardProgressStep.value
  }, 1000)
})

watch(
  () => wizardProgressStep.value,
  (newVal) => {
    progress.value = newVal
  }
)

const goToNextStep = async () => {
  const { wizardStep } = store.bookingProgress
  let changeStepBy = 1

  if (wizardStep === 1) {
    await postTicketRequest()
  } else if (wizardStep === 2) {
    if (store.getConcessionsAllowed) {
      await postConcessionsRequest()
    } else {
      await getContestInformation()
      router.replace({
        name: stepsRoutes[wizardStep + 3],
        params: { ...router.currentRoute.value.params },
      })
      store.updateBookingWizard(wizardStep + 2)
      changeStepBy = 2
    }
  } else if (wizardStep === 3) {
    await postAddConcessionsRequest()
    await getContestInformation()
    scrollToTop()
  } else if (wizardStep === 4) {
    document.getElementById(constants.buttonPaymentSubmitId).click()
  } else {
    router.replace({
      name: stepsRoutes[wizardStep + 2],
      params: { ...router.currentRoute.value.params },
    })
    store.updateBookingWizard(wizardStep + 1)
    scrollToTop()
    hideHeaderLinks()
  }
  emit('changeStep', wizardStep + changeStepBy)
}

const postTicketRequest = async () => {
  isLoading.value = true
  removeErrors()
  const allSelectedTickets = []
  // read all selected tickets
  for (const key in selectedTickets.value) {
    if (key) {
      const obj = selectedTickets.value[key]

      allSelectedTickets.push({
        ticketTypeCode: key,
        quantity: obj.count,
        priceInCents: Math.round(obj.ticketPrice * 100),
        offerId: obj.offerId || 0,
        codes: obj.codes,
      })
    }
  }

  for (const userVoucher of userVouchersCodes.value) {
    if (userVoucher) {
      allSelectedTickets.push({
        ticketTypeCode: '',
        quantity: 1,
        priceInCents: 0,
        offerId: 0,
        codes: [userVoucher.code],
      })
    }
  }

  const postData = {
    ticketTypes: allSelectedTickets,
    cinemaId: selectedCinema.value.value,
    sessionId: selectedRoom.value.id,
    userSessionId: store.bookingProgress.usersessionId,
  }

  await postRequestHandler({
    postData,
    endpoint: endpointChooseTickets,
    successCallback: handleSuccess,
    errorCallback: handleError,
    refreshTokenHandler: refresh,
    captchaAction: captchaTicketAction,
  })
}

const postConcessionsRequest = async () => {
  isLoading.value = true
  removeErrors()
  const postData = {
    cinemaId: selectedCinema.value.value,
    sessionId: selectedRoom.value.id,
    language: language,
    userSessionId: store.bookingProgress.usersessionId,
  }
  await postRequestHandler({
    postData,
    endpoint: endpointFetchShopItems,
    successCallback: handleShopSuccess,
    errorCallback: handleError,
    refreshTokenHandler: refresh,
    captchaAction: captchaShopAction,
  })
}

const postAddConcessionsRequest = async () => {
  isLoading.value = true
  removeErrors()

  const postData = {
    cinemaId: selectedCinema.value.value,
    concessions: Object.keys(store.getAllSelectedProducts).map((id) => ({
      itemId: id,
      quantity: store.getAllSelectedProducts[id].count,
      recognitionId: store.getAllSelectedProducts[id].recognitionId,
    })),
    userSessionId: store.bookingProgress.usersessionId,
  }
  await postRequestHandler({
    postData,
    endpoint: endpointAddShopItems,
    successCallback: handleSuccess,
    errorCallback: handleError,
    refreshTokenHandler: refresh,
    captchaAction: captchaAddShopItemsAction,
  })
}

const getContestInformation = async () => {
  const postData = {
    cinemaId: selectedCinema.value.value,
    filmId: selectedMovie.value.movieId,
    userSessionId: store.bookingProgress.usersessionId,
  }

  await postRequestHandler({
    postData,
    endpoint: endpointCheckContest,
    successCallback: handleContestSuccess,
    errorCallback: handleError,
    refreshTokenHandler: refresh,
  })
}

const handleShopSuccess = async (response) => {
  isLoading.value = false
  const { wizardStep } = store.bookingProgress
  const { shopItems } = response.data
  store.setShopItems(shopItems)
  router.replace({
    name: stepsRoutes[wizardStep + 2],
    params: { ...router.currentRoute.value.params },
  })
  store.updateBookingWizard(wizardStep + 1)
}

const handleContestSuccess = async (response) => {
  store.setContestData(response.data)
}

const handleSuccess = async () => {
  isLoading.value = false
  const { wizardStep } = store.bookingProgress
  router.replace({
    name: stepsRoutes[wizardStep + 2],
    params: { ...router.currentRoute.value.params },
  })
  store.updateBookingWizard(wizardStep + 1)
}

const removeErrors = () => {
  store.assignGlobalErrorMessages([])
}

const handleError = async (messages) => {
  isLoading.value = false
  if (!messages) {
    showError(dictionary.defaultErrorMessage)
  } else {
    showError(messages)
  }
}

const showError = (mess) => {
  if (typeof mess === 'string') {
    store.assignGlobalErrorMessages([mess])
  } else {
    store.assignGlobalErrorMessages([...mess])
  }
}

const restartBooking = async () => {
  const postData = {
    userSessionId: store.bookingProgress.usersessionId,
  }

  await postRequestHandler({
    postData,
    endpoint: configuration.endpointRestartBooking,
    successCallback: () => {
      window.location.reload()
    },
    errorCallback: () => {
      alert('An error occured')
    },
    refreshTokenHandler: refresh,
    captchaAction: configuration.captchaRestartBooking,
  })
}

const getRoomType = (screen) => {
  return store.getRoomType(screen)
}

const getShowTime = (date) => {
  return extractFullTimeFromDate(date)
}

const openCollapse = ref(false)

const collapseOpened = computed(() => {
  return openCollapse.value ? 'b-booking-progress__mobile__expand__open' : ''
})

const childcollapseOpened = computed(() => {
  return openCollapse.value
    ? 'b-booking-progress__mobile__expand__open__header'
    : ''
})

const openExpand = () => {
  openCollapse.value = !openCollapse.value
}

const hideHeaderLinks = () => {
  jQuery('.js-creditnote').remove()
  jQuery('.js-login').remove()
}
</script>
<style lang="scss" scoped>
.loader {
  position: fixed;
}
</style>
